import React from 'react'
import './SearchButton.scss'

const SearchButton = ({ text, onClick, disabled, loading }) => {

  return (
    <div className={`search-button-container ${disabled ? 'disabled' : ''}`} onClick={() => disabled ? null : onClick()}>
      <p >{text} </p>
      {
        (loading) &&
        <img
          alt={'Loading'}
          src={require('../../../../assets/images/loading.gif')}
          className="loading-icon"
        />
      }
    </div>
  )

}

export default SearchButton
